module.exports = __webpack_public_path__ + "static/media/hadriankanal_tn.43f58be8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/hadriankanal_tn.jpg
// module id = 678
// module chunks = 0